module.exports = __webpack_public_path__ + "img/paciente_nino.c25ce399.svg";